export default {
  'SET_CAMERAS'(state, data) {
    state.cameras = data;
  },
  'ADD_CAMERA'(state, data) {
    state.cameras.push(data);
  },
  'REPLACE_CAMERA'(state, data) {
    state.cameras = state.cameras.map(item => {
      if (parseInt(item.id) === parseInt(data.id)) {
        return data;
      }

      return item;
    });
  },
  'REMOVE_CAMERA'(state, id) {
    state.cameras = state.cameras.filter(item => {
      return parseInt(item.id) !== parseInt(id);
    });
  },
  'SET_MOTION_CYCLE'(state, value) {
    state.motionCycle = value;
  }
};